module.exports = __webpack_public_path__ + "static/media/compare-button-selected-none.a35e63c3.svg";